import { Icon } from "PFComponents/icon";
import React from "react";
import { useTranslation } from "react-i18next";

import css from "../localisation.module.scss";

type TranslationsCounterLabelProps = {
  allStrings: number;
  missingStrings: number;
};

export const TranslationsCounterLabel = ({ allStrings, missingStrings }: TranslationsCounterLabelProps) => {
  const { t } = useTranslation("admin", { keyPrefix: "localisation.table.values" });

  if (missingStrings) {
    return (
      <span className={css.translationCounterLabel}>
        <Icon name="warning" color="paletteRed0" size="md" />
        {t("missingStrings", { amount: missingStrings })}
      </span>
    );
  }

  return (
    <span className={css.translationCounterLabel}>
      <Icon name="check" color="paletteGreen0" size="md" />
      {t("strings", { amount: allStrings })}
    </span>
  );
};
